import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; 
import { combineReducers } from 'redux';
import userReducer from './features/userSlice'; 
import globalLoaderReducer from "./features/globalLoaderSlice";
 
const rootReducer = combineReducers({
  user: userReducer, 
  globalLoader: globalLoaderReducer,
});
 
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'],  
}; 
const persistedReducer = persistReducer(persistConfig, rootReducer);
 
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,  
    }),
});
 
export const persistor = persistStore(store);
export default store;
